const config = require(`./${process.env.NODE_ENV}`).default
export default config


// WEBPACK FOOTER //
// ./src/config/index.js